module.exports = __webpack_public_path__ + "img/electric-bolt.61d41ec0.webp";